<template>
  <div class="systemDoor">
    <el-divider content-position="left">按条件搜索</el-divider>
    <el-row :gutter="10" class="filter">
      <el-col :span="8">
        <span class="label">门店</span>
        <el-input
          v-model="tableConfig.searchTerm"
          placeholder="检查ID或名称"
          style="width: auto"
        ></el-input>
      </el-col>
    </el-row>
    <br />
    <el-divider content-position="left">功能按钮</el-divider>
    <el-row >
      <el-col :span="2" :offset="1">
        <div class="grid-content bg-alex"><el-button type="primary" @click="">生成报表</el-button></div>
      </el-col>
      <el-col :span="2" :offset="1">
        <div class="grid-content bg-alex"><el-button type="primary" @click="">重 置</el-button></div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "ReportManage",
  data() {
    return {
      tableConfig:{
        regionNo:'',
      }
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style lang="sass" scoped>
.systemDoor
  padding: 20px 10px
  box-sizing: border-box
  border-radius: 4px
  background: #fff
  input[type=file]
    display: none
  .label
    display: inline-block
    width: 70px
  footer
    padding-top: 20px
    text-align: right

  .el-form
    .el-select
      width: 100%

  .bg-alex1
    background: #d3dce6
</style>



// WEBPACK FOOTER //
// src/vms/pages/views/ReportManage.vue